import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { MapService } from 'src/app/Services/map.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { User } from '../../driver/create-driver/create-driver.component';

@Component({
  selector: 'g10-create-guest',
  templateUrl: './create-guest.component.html',
  styleUrls: ['./create-guest.component.css']
})
export class CreateGuestComponent implements OnInit {

  matFormSize = '13px';
  guestForm: FormGroup;
  public guestLocation = {};

  formSubmit:boolean=false;

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService
  ) {
  }

  ngOnInit(): void {

    this.addFormLoad();
  }

  addFormLoad() {
    this.guestForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      gender: new FormControl('', [Validators.required]),
      mobileNo: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      userType: new FormControl('',[Validators.required]),
      location: new FormControl('', [Validators.required]),
    });
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.guestForm.controls[controlName].hasError(errorName);
  }

  getLocation(obj){
    console.log(obj);
    this.guestLocation = {...obj};
  }  

  onSubmit() {
    this.formSubmit = true;
    if (!this.guestForm.valid) { return; }
    const obj = {
      ...this.guestForm.value,
    };
    obj['lat']=this.guestLocation['lat'];
    obj['lng']=this.guestLocation['lng'];
    console.log(obj);
    this.api.transportManagerGuestCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/guest/view-guest'])
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
